// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UAo5","col":"styles_col__3OJFX"};